var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoringFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "942C1165-ECF1-4CAD-B806-26D37FFEB29F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative-emotion_change-emotion",
    transform: "translate(-49.000000, -639.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "negative-emotion-copy",
    transform: "translate(0.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boring-face",
    transform: "translate(16.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71572875,0 0,6.71572875 0,15 C0,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9906315,6.71961243 23.2803876,0.00936852177 15,0 Z",
    fill: "#6384B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,9.6 C8.28311553,9.40808653 8.53497801,9.29678972 8.8001643,9.29060079 C9.0653506,9.28441186 9.32213094,9.38383794 9.514,9.567 C10.1241916,10.1214595 11.0558084,10.1214595 11.666,9.567 C11.9248389,9.32066537 12.2954339,9.23113171 12.6381854,9.33212547 C12.9809369,9.43311924 13.2437728,9.70929708 13.3276854,10.0566255 C13.411598,10.4039539 13.3038389,10.7696654 13.045,11.016 C11.6696806,12.3259683 9.50831936,12.3259683 8.133,11.016 C7.94047839,10.8328119 7.82879107,10.5805261 7.82259945,10.3148494 C7.81640784,10.0491726 7.9162212,9.79195785 8.1,9.6 L8.1,9.6 Z",
    fill: "#ECF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.041,22.662 C20.675576,23.0757583 20.0440021,23.1151477 19.63,22.75 C16.9842693,20.4167429 13.0157307,20.4167429 10.37,22.75 C10.1035227,22.9964982 9.72439163,23.0792316 9.37944888,22.9661563 C9.03450614,22.8530811 8.77792875,22.561957 8.70909236,22.20554 C8.64025597,21.849123 8.76997207,21.4833923 9.048,21.25 C12.448746,18.2534561 17.547254,18.2534561 20.948,21.25 C21.1477167,21.4248229 21.2697381,21.6718728 21.2871822,21.9367228 C21.3046263,22.2015727 21.2160618,22.4624927 21.041,22.662 L21.041,22.662 Z",
    fill: "#ECF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.69,11.017 C20.3145481,12.3276034 18.1524519,12.3276034 16.777,11.017 C16.5185183,10.7703081 16.41128,10.4044571 16.4956806,10.0572595 C16.5800812,9.71006183 16.8432983,9.43426519 17.1861806,9.33375946 C17.5290629,9.23325372 17.8995183,9.32330811 18.158,9.57 C18.7681916,10.1244595 19.6998084,10.1244595 20.31,9.57 C20.5668406,9.31445771 20.9418136,9.21782753 21.2901699,9.31741118 C21.6385261,9.41699482 21.9057703,9.69721387 21.9887393,10.0498966 C22.0717083,10.4025794 21.9574228,10.7725537 21.69,11.017 Z",
    fill: "#ECF3FF"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoringFace);
export default __webpack_public_path__ + "static/media/boring-face.503b6ec8c9c47a39f1371dae2d3345b7.svg";
export { ForwardRef as ReactComponent };